/**
 * ANX-116 — Enter отправляет сообщение, Shift+Enter переносит строку.
 *
 * Возвращает true, если нажатие должно отправить сообщение (а не вставить
 * перенос строки). Исключения, при которых отправлять НЕ нужно:
 *   - зажат Shift (Shift+Enter = перенос строки);
 *   - идёт IME-композиция (Enter подтверждает кандидата ввода — китайский/
 *     японский/корейский и т.п., отправлять рано).
 */
export function isSendKey(e: {
  key: string;
  shiftKey: boolean;
  isComposing?: boolean;
}): boolean {
  return e.key === 'Enter' && !e.shiftKey && !e.isComposing;
}
